<template>
  <div id="guide" @scroll="getHeight">
    <div class="title">
      <img class="title1" src="@/assets/img/taiko/guide/header_1.png" alt="" />
      <img
        v-if="page !== 6"
        class="introduction"
        src="@/assets/img/taiko/guide/header_2.png"
        alt=""
      />
      <img
        v-else
        class="introduction"
        src="@/assets/img/taiko/guide/header_4.png"
        alt=""
      />
    </div>
    <div class="content">
      <div class="content_handle" v-if="page !== 6">
        <div class="handle_row">
          <img
            :class="{ button_gray: page !== 1 }"
            src="@/assets/img/taiko/guide/button_1.png"
            @click="scrollToSomeY(1, 340)"
            alt=""
          />
          <img
            :class="{ button_gray: page !== 2 }"
            src="@/assets/img/taiko/guide/button_2.png"
            @click="scrollToSomeY(2, 900)"
            alt=""
          />
        </div>
        <div class="handle_row">
          <img
            :class="{ button_gray: page !== 3 }"
            src="@/assets/img/taiko/guide/button_3.png"
            @click="scrollToSomeY(3, 340)"
            alt=""
          />
          <img
            :class="{ button_gray: page !== 4 }"
            src="@/assets/img/taiko/guide/button_4.png"
            @click="scrollToSomeY(4, 985)"
            alt=""
          />
        </div>
        <div class="handle_row">
          <img
            class="button5"
            :class="{ button_gray: page !== 5 }"
            src="@/assets/img/taiko/guide/button_5.png"
            @click="scrollToSomeY(5, 112)"
            alt=""
          />
        </div>
      </div>
      <div class="content_main" v-if="page === 1 || page === 2">
        <div class="block">
          <div class="content_main_title">
            <img
              src="@/assets/img/taiko/guide/content/content_title1.png"
              alt=""
            />
          </div>
          <div class="content_main_content">
            <img src="@/assets/img/taiko/guide/content/content_1.png" alt="" />
          </div>
        </div>
        <div class="block">
          <div class="stars"></div>
          <div class="content_main_title">
            <img
              src="@/assets/img/taiko/guide/content/content_title2.png"
              alt=""
            />
          </div>
          <div class="content_main_content">
            <img src="@/assets/img/taiko/guide/content/content_2.png" alt="" />
          </div>
        </div>
      </div>
      <div class="content_main" v-else-if="page === 3 || page === 4">
        <div class="block">
          <div class="content_main_title">
            <img
              src="@/assets/img/taiko/guide/content/content_title3.png"
              alt=""
            />
          </div>
          <div class="content_main_content">
            <img src="@/assets/img/taiko/guide/content/content_3.png" alt="" />
          </div>
        </div>
        <div class="block">
          <div class="stars"></div>
          <div class="content_main_title">
            <img
              src="@/assets/img/taiko/guide/content/content_title4.png"
              alt=""
            />
          </div>
          <div class="content_main_content">
            <img src="@/assets/img/taiko/guide/content/content_4.png" alt="" />
          </div>
        </div>
      </div>
      <div class="content_main" v-else-if="page === 5">
        <div class="block">
          <div class="content_main_title">
            <img
              src="@/assets/img/taiko/guide/content/content_title5.png"
              alt=""
            />
          </div>
          <div class="content_main_content">
            <img class="content5_mg" src="@/assets/img/taiko/guide/content/content_5.png" alt="" />
          </div>
        </div>
      </div>
      <div class="content_main" v-else-if="page === 6">
        <div class="block">
          <div class="stars"></div>
          <div class="content_main_title_5">
            <img
              src="@/assets/img/taiko/guide/content/content_title6.png"
              alt=""
            />
          </div>
          <div class="update">
            <span class="time">2023年3月10日</span>
            <span class="normal_text bold">在线更新</span>
          </div>
          <div class="content_main_title_5">
            <img
              src="@/assets/img/taiko/guide/content/content_title7.png"
              alt=""
            />
          </div>
          <div class="update">
            <span class="normal_text">《太鼓达人》 NEW Version</span>
            <span class="normal_text">本次更新16首新歌/谱！</span>
            <span class="normal_text">将有2个新领域、10个新伙伴登场！</span>
          </div>
          <div class="content_main_content">
            <!-- <img src="@/assets/img/taiko/guide/content/new.png" alt="" /> -->
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="stars"></div>
        <img
          v-if="page !== 6"
          class="back"
          @click="scrollToTop"
          src="@/assets/img/taiko/guide/footer_back.png"
          alt=""
        />
        <div class="bg">
          <img src="@/assets/img/taiko/guide/footer_bg.png" alt="" />
          <img src="@/assets/img/taiko/guide/footer_logo.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "guide",
  data() {
    return {
      scrollTop: 0,
      page: 1,
    };
  },

  mounted() {
    //获取url传参的page的参数
    let type = this.$route.query.type;
    console.log(type);
    if (Number(type) === 1) {
      this.page = 6;
    }
    //监听滚动的Y轴并log返回Y轴的值
    const element = document.getElementById("guide");
    element.addEventListener("scroll", this.getHeight);
  },
  beforeDestroy() {
    const element = document.getElementById("guide");
    element.removeEventListener("scroll", this.getHeight);
  },
  methods: {
    getHeight() {
      const element = document.getElementById("guide");
      let scrollTop = element.scrollTop;
      this.scrollTop = scrollTop;
      // console.log(scrollTop);
      // if(this.page<5){
      //   if(scrollTop<=360){
      //     if(this.page>2 && this.page<5){
      //       this.page = 3;
      //     }else{
      //       this.page = 1;
      //     }
      //   }
      // }
    },
    scrollToSomeY(page, point) {
      this.page = page;
      // console.log('someY',point)
      let timer = setInterval(() => {
        const element = document.getElementById("guide");
        let ispeed = Math.floor((point - element.scrollTop) / 30);
        element.scrollBy(this.scrollTop, this.scrollTop + ispeed);
        if (element.scrollTop >= point) {
          element.scrollTop = point;
          clearInterval(timer);
        }
      }, 22);
    },
    scrollToTop() {
      // console.log('back')
      let timer = setInterval(() => {
        const element = document.getElementById("guide");
        let ispeed = Math.floor(this.scrollTop / 6);
        element.scrollTop = this.scrollTop - ispeed;
        if (element.scrollTop <= 6) {
          // element.scrollTop === 0;
          clearInterval(timer);
        }
      }, 22);
    },
  },
};
</script>

<style lang='scss' scoped>
@import "assets/scss/index.scss";
@import "./index.scss";
</style>